/* eslint-disable no-unused-vars */
/* eslint-disable no-const-assign */
import React, { useState, useEffect } from "react";
import "./../../../assets/css/purchase/form.css";
import DeliveryModalS from "../../components/Modal/DeliverymodalSearch";
import Datetime from "react-datetime";
import moment from "moment";
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";
import {
  formatDateOnChange,
  formatStringDateToDate,
} from "../../../utils/DateUtils";
import {
  getAlert,
  getData,
  getDataWithComp,
  getDataWithJoin,
  getSoWithoutPK,
} from "../../../utils/SamuiUtils";
import Navbar from "../../components/Modal/Navbar";

const ReceivablesReport = () => {
  const [name, setName] = useState(null);

  const [searchCriteria, setSearchCriteria] = useState({
    docDate: formatStringDateToDate(new Date()),
    dateTo: null,
  });

  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataSub, setFilteredDataSub] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = () => setShowSoModal(true);
  const handleSoClose = () => setShowSoModal(false);
  const [soDataList, setSoDataList] = useState([]);
  const [dlLineList, setDlLineList] = useState([]);
  const [formDetailList, setFormDetailList] = useState([]);
  const [carList, setCarList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deliveryLineId, setDeliveryLineId] = useState(null);
  const [dlLineName, setDlLineName] = useState("");
  const [dlSelected, setDlSelected] = useState({ DL_Id: "" });
  const [arCodeFrom, setArCodeFrom] = useState("");
  const [arCodeTo, setArCodeTo] = useState("");

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setName("6.3 รายงานนำส่งรายได้");
    setFilteredData([]);
    const dlDataList = await getDataWithComp("DL_Line_H", "ORDER By DL_Id ASC");

    if (dlDataList && dlDataList.length > 0) {
      setDlLineList(dlDataList);
    }
  };

  const resetValues = () => {
    setSearchCriteria({
      docDate: formatStringDateToDate(new Date()),
      dateTo: null,
    });
    setDlSelected({ DL_Id: "" });
    setArCodeFrom("");
    setArCodeTo("");
    setFilteredData([]);
    setCurrentPage(1);
    setCarList([]);
    setDriverList([]);
    setSoDataList([]);
    setFilteredDataSub([]);
  };

  const onRowSelectDL = async (dlSelected) => {
    try {
      setIsLoading(true);
      setDlSelected(dlSelected);
      handleSoClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleChangeDate = (value, name) => {
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : "";
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleSearch = async () => {
    try {
      if (searchCriteria.docDate === "" || searchCriteria.docDate === null) {
        return getAlert("FAILED", "กรุณาระบุ วันที่เอกสาร");
      }

      if (dlSelected?.DL_Id === "" || dlSelected?.DL_Id === null) {
        return getAlert("FAILED", "กรุณาระบุ สายรถ");
      }

      setFilteredData([]);

      const response = await getDataWithJoin(
        `
            PK_H.Doc_Id,
            SO_H.Doc_No,
            PK_D.AR_Name,
            SO_H.Total_Before_Vat,
            SO_H.VAT,
            SO_H.NetTotal,
            SO_H.Pay_Total,
            SO_H.Doc_Status_Paid_Type,
            CASE
                WHEN SO_H.Doc_Status_Paid_Type = 1 THEN 'เงินสด'
                WHEN SO_H.Doc_Status_Paid_Type = 2 THEN 'โอน'
                WHEN SO_H.Doc_Status_Paid_Type = 3 THEN 'เช็ค'
                WHEN SO_H.Doc_Status_Paid_Type = 4 THEN 'เครดิต'
                WHEN SO_H.Doc_Status_Paid_Type = 5 THEN 'ค้างจ่าย'
                ELSE 'ไม่ระบุ'
            END AS PaymentType,
            PK_H.Driver1,
            (SELECT TOP 1 LEFT(SD.Item_Code, 3) FROM API_0702_SO_D SD WHERE SD.Doc_ID = SO_H.Doc_ID ORDER BY SD.Item_Code) AS Item_Code,
            SUM(SO_D.Item_Qty) AS Total_Item_Qty,
            PK_H.PK_Round 
            `,
        `API_0801_PKList_H AS PK_H`,
        `
            LEFT JOIN API_0802_PKList_D AS PK_D ON PK_H.Doc_Id = PK_D.Doc_Id
            LEFT JOIN API_0701_SO_H AS SO_H ON PK_D.SO_Id = SO_H.Doc_ID
            LEFT JOIN API_0702_SO_D AS SO_D ON SO_H.Doc_ID = SO_D.Doc_ID
            WHERE
                PK_H.Doc_Date = '${formatStringDateToDate(
                  searchCriteria.docDate
                )}'
                AND PK_H.Comp_Id = ${window.localStorage.getItem("company")}
                AND PK_H.Delivery_Line_Id = ${dlSelected?.DL_Id}
                AND PK_D.SO_Id IS NOT NULL 
                AND PK_H.PK_Round = ${
                  dlSelected?.PK_Round || 1
                } AND PK_H.Doc_Status = 5
            GROUP BY
            SO_H.Doc_No,
            SO_H.Doc_ID,
            PK_H.Doc_Id,
            PK_D.AR_Name,
            SO_H.Total_Before_Vat,
            SO_H.VAT,
            SO_H.NetTotal,
            SO_H.Pay_Total,
            SO_H.Doc_Status_Paid_Type,
            PK_H.Driver1,
            PK_H.PK_Round;
            `,
        ""
      );

      if (response && response.length > 0) {
        setFilteredData(response);
        const responseSub = await getDataWithJoin(
          `*`,
          `PKList_CloseMoney AS PC`,
          `WHERE PKList_Id = ${response[0].Doc_Id}`,
          ""
        );
        if (responseSub && responseSub.length > 0) {
          setFilteredDataSub(responseSub);
        } else {
          setFilteredDataSub([]);
        }
      } else {
        setFilteredData([]);
        getAlert("WARNING", "ไม่พบข้อมูล");
      }
    } catch (error) {
      getAlert("FAILED", error.response?.message || error.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/vansale-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <form className="row">
                      <div className="col-auto">
                        <label htmlFor="docDate" className="form-label">
                          วันที่เอกสาร
                        </label>
                        <Datetime
                          id="docDate"
                          className="input-spacing-input-date"
                          value={searchCriteria.docDate}
                          key={searchCriteria.docDate}
                          dateFormat="DD-MM-YYYY"
                          timeFormat={false}
                          onChange={(date) => handleChangeDate(date, "docDate")}
                          inputProps={{ readOnly: true, disabled: false }}
                        />
                      </div>
                      <div className="col-auto">
                        <label className="form-label">สายรถ</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control input-spacing"
                            name="apCode"
                            value={dlSelected?.DL_LineName || ""}
                            disabled={true}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSoShow();
                            }}
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>
                      </div>
                      <div className="col-auto">
                        <label className="form-label">ช่วงเวลาส่ง</label>
                        <select
                          className="form-select"
                          name="deliveryTime"
                          value={dlSelected?.PK_Round || ""}
                          onChange={(e) =>
                            setDlSelected({
                              ...dlSelected,
                              PK_Round: e.target.value,
                            })
                          }
                          disabled={false}
                        >
                          <option value="1">เช้า</option>
                          <option value="2">บ่าย</option>
                          <option value="3">เย็น</option>
                        </select>
                      </div>

                      <div className="col-md-12 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            marginRight: "20px",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => handleSearch()}
                        >
                          <i className="fas fa-search" /> ค้นหา
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => resetValues()}
                        >
                          <i className="fas fa-undo" /> เริ่มใหม่
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <DeliveryModalS
                showSoModal={showSoModal}
                handleSoClose={handleSoClose}
                soDataList={soDataList}
                dlLineList={dlLineList}
                onRowSelectDL={onRowSelectDL}
              />

              <ReportsTable
                currentItems={currentItems}
                currentPage={currentPage}
                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                dataMasterList={filteredData}
                itemsPerPage={itemsPerPage}
                fieldMappings={{
                  Doc_No: "Doc_No",
                  AR_Name: "AR_Name",
                  Total_Before_Vat: "Total_Before_Vat",
                  VAT: "VAT",
                  NetTotal: "NetTotal",
                  PK_Round: "PK_Round",
                  Pay_Total: "Pay_Total",
                  Doc_Status_Paid_Type: "Doc_Status_Paid_Type",
                  PaymentType: "PaymentType",
                  Driver1: "Driver1",
                  totalQty: "Total_Item_Qty",
                  Item_Code: "Item_Code",
                }}
              />
              <div className="col-md-12 mt-4">
                <div className="card">
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "550px", overflowY: "auto" }}
                    >
                      <table
                        id="basic-datatables"
                        className="table table-striped table-hover"
                        style={{ width: "50%", margin: "auto" }}
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center">สรุปยอดเงิน</th>
                            <th className="text-center">จำนวนธนบัตร/เหรียญ</th>
                            <th className="text-center">จำนวนเงินรวม</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredDataSub.map((o, index) => (
                            <React.Fragment key={index}>
                              <tr>
                                <td className="text-center">1,000 บาท</td>
                                <td className="text-center">{o.B1000}</td>
                                <td className="text-center">
                                  {o.B1000 * 1000}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">500 บาท</td>
                                <td className="text-center">{o.B500}</td>
                                <td className="text-center">{o.B500 * 500}</td>
                              </tr>
                              <tr>
                                <td className="text-center">100 บาท</td>
                                <td className="text-center">{o.B100}</td>
                                <td className="text-center">{o.B100 * 100}</td>
                              </tr>
                              <tr>
                                <td className="text-center">50 บาท</td>
                                <td className="text-center">{o.B50}</td>
                                <td className="text-center">{o.B50 * 50}</td>
                              </tr>
                              <tr>
                                <td className="text-center">20 บาท</td>
                                <td className="text-center">{o.B20}</td>
                                <td className="text-center">{o.B20 * 20}</td>
                              </tr>
                              <tr>
                                <td className="text-center">10 บาท</td>
                                <td className="text-center">{o.B10}</td>
                                <td className="text-center">{o.B10 * 10}</td>
                              </tr>
                              <tr>
                                <td className="text-center">5 บาท</td>
                                <td className="text-center">{o.B5}</td>
                                <td className="text-center">{o.B5 * 5}</td>
                              </tr>
                              <tr>
                                <td className="text-center">2 บาท</td>
                                <td className="text-center">{o.B2}</td>
                                <td className="text-center">{o.B2 * 2}</td>
                              </tr>
                              <tr>
                                <td className="text-center">1 บาท</td>
                                <td className="text-center">{o.B1}</td>
                                <td className="text-center">{o.B1 * 1}</td>
                              </tr>
                              <tr className="table-primary">
                                <td className="text-center">
                                  <b>รวม</b>
                                </td>
                                <td className="text-center">
                                  <b>
                                    {o.B1 +
                                      o.B2 +
                                      o.B5 +
                                      o.B10 +
                                      o.B20 +
                                      o.B50 +
                                      o.B100 +
                                      o.B500 +
                                      o.B1000}
                                  </b>
                                </td>
                                <td className="text-center">
                                  <b>
                                    {o.B1 * 1 +
                                      o.B2 * 2 +
                                      o.B5 * 5 +
                                      o.B10 * 10 +
                                      o.B20 * 20 +
                                      o.B50 * 50 +
                                      o.B100 * 100 +
                                      o.B500 * 500 +
                                      o.B1000 * 1000}
                                  </b>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceivablesReport;
